import { View } from 'foundations-components/transitional/components/View';

/*
 * Custom Card component for My Team page to avoid table rendering issues.
 * The existing CardWrapper from foundations-components causes tables to behave weirdly.
 * See: https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-table--page#bordered-table-in-a-card
 */
import { jsx as _jsx } from "react/jsx-runtime";
const Card = props => {
  return /*#__PURE__*/_jsx(View, Object.assign({
    backgroundColor: "fill-surface-default",
    borderColor: "border-container-default",
    borderRadius: "300",
    borderStyle: "solid",
    borderWidth: "100",
    boxShadow: "100",
    marginBlockStart: "400",
    padding: "600"
  }, props));
};
export default Card;